<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/Ilustracion.gif" alt="login" class="mx-auto" style="max-width:100%">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 py-12">

                <div class="vx-card__title mb-12">
                  <img src="@/assets/images/logo/logo.png" alt="login" class="mx-auto my-6" style="max-width:100%">
                  <img src="@/assets/images/logo/logo_meli.png" alt="login" class="mx-auto my-6" style="max-width:100%">
                </div>


                <div class="mt-6 mb-2 text-center">
                  <div v-if="errorMessage">
                    <div class="text-error">{{errorMessage}}</div>
                  </div>
                  <div v-else>
                     <div>Autenticando....</div> 
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// Con alias: el componente ya tiene un `errorMessage` en data y se confunden al leer.
import { errorMessage as readableError } from '@/http';

/** `do-login` responde 200 con { valid:false } para los errores de negocio; el try/catch cubre el dia en que pase a 4xx. */
const FALLBACK = 'No se pudo iniciar sesión. Volvé a intentarlo desde el panel de Cruz del Sur.';

/** Sin sesion: un 401/419 aca es un rechazo de credenciales. Ver `skipAuthRedirect` en src/http.js. */
const NO_SESSION = { skipAuthRedirect: true };

export default {

    data(){
      return {
        passedData: {},
        errorMessage: null
      }
    },
    
    async mounted() {
        this.passedData = this.$route.query;
        try {
          await this.getSanctumCSRFToken();
          const loginResp = await this.doLogin();
          const data = loginResp.data || {};
          if (data.valid) {
            window.location.href = data.redirect_to_url
          } else {
            this.errorMessage = data.message || FALLBACK
          }
        } catch (error) {
          this.errorMessage = readableError(error, FALLBACK)
        }
    },

    methods: {

        getSanctumCSRFToken(){
            return axios.get( process.env.VUE_APP_BACKEND_URL + 'sanctum/csrf-cookie', NO_SESSION);
        },

        doLogin(){
            return axios.post( process.env.VUE_APP_BACKEND_URL + 'api/do-login', this.passedData, NO_SESSION);
        }

    }
    
}
</script>